import { apiClient } from "./client";
import type { SearchResponse } from "./types";

/**
 * Hit GET /search?q&limit. The backend requires q with at least 2 chars;
 * we still send shorter strings so the caller can decide whether to skip,
 * but most callers should debounce + length-check before calling.
 */
export async function globalSearch(
  q: string,
  limit = 5,
): Promise<SearchResponse> {
  const res = await apiClient.get<SearchResponse>("/search", {
    params: { q, limit },
  });
  return res.data;
}
